// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__92GsF","inner":"Footer_inner__tMIGv","innerMobile":"Footer_innerMobile__h2JA0","bottom":"Footer_bottom__VGbwO","top":"Footer_top__O8OKN"};